import { render, staticRenderFns } from "./distiAccount.vue?vue&type=template&id=4523f394&scoped=true"
import script from "./distiAccount.vue?vue&type=script&lang=js"
export * from "./distiAccount.vue?vue&type=script&lang=js"
import style0 from "./distiAccount.vue?vue&type=style&index=0&id=4523f394&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4523f394",
  null
  
)

export default component.exports